import { useMutation, useQueryClient } from '@tanstack/react-query';

import { useAuthSession } from '@/features/auth/useAuthSession';
import { deleteGeneration } from '@/services/generations';

export function useDeleteGenerationMutation() {
  const { session } = useAuthSession();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (generationId: string) => {
      if (!session) {
        return Promise.reject(new Error('Нет активной сессии.'));
      }

      return deleteGeneration(generationId, session.access_token);
    },
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: ['history'] });
    },
  });
}
